// 图片元素的覆层组件
import React, { useState, useMemo, useRef } from 'react';
import { useProjectState } from '@starflow/app/store';
import { useDerivativeTasks, DerivativeResultActions } from '@starflow/app/modules/derivative';
import { DerivativeResults, DerivativeQueue, DerivativeTask, HoverDiffViewer } from '@starflow/app/modules/derivative';
import { useUnit } from '@starflow/app/store';
import { translate } from '@shakkerai/util-i18n';
import { findMatchedResultIndex } from '@starflow/app/helpers/flow';

export const GeneratorOverlayer = ({ isMiniMode, viewport, element }) => {
  const currentNodeId = useProjectState('currentNodeId');
  const unitId = element.lastDerivativeUnitId;
  const tasks = useDerivativeTasks(unitId);
  const unit = useUnit(unitId);
  const matchedResultIndex = findMatchedResultIndex(unitId);
  // 先从unit.result中取selectedIndex, 如果为空, 则根据matchedResultIndex判断
  const [selectedIndex, setSelectedIndex] = useState(
    unit.result?.selectedIndex ?? (matchedResultIndex === tasks.length - 1 ? -1 : matchedResultIndex),
  ); // -1: 原图, >=0: 选择的任务索引 生成器最后一项是原图
  const selectedItem = tasks[selectedIndex];
  const resultsRef = useRef(null);

  const previewContent = useMemo(() => {
    if (!selectedItem) {
      return null;
    }

    if (selectedItem.type === 'queue') {
      return <DerivativeQueue data={selectedItem} />;
    }

    if (selectedItem.type === 'task') {
      return <DerivativeTask data={selectedItem} />;
    }

    return null;
  }, [element.url, unit, viewport.scale, selectedItem]);

  const handleCancel = () => {
    resultsRef.current?.handleSelect(-1);
  };

  return (
    <>
      {!isMiniMode && (
        <DerivativeResults
          ref={resultsRef}
          items={tasks}
          elementId={element.id}
          flowId={element.flowId}
          selected={selectedIndex}
          onSelect={setSelectedIndex}
          sourceElement={tasks[tasks.length - 1]} // generator没有sourceElement, 取results的最后一项
          isGenerator={true}
          currentNodeId={currentNodeId}
        />
      )}
      <div className="absolute -inset-0.5 border-2 border-primary">
        <div className="absolute -top-5 left-0 flex items-center h-4 text-primary whitespace-nowrap text-[10px]">
          <div className="w-2 h-2 border border-primary rotate-45 mr-1" />
          <span>
            {unit.label} - {translate('generte_title')}
          </span>
        </div>
        {previewContent}
      </div>
      <div className="absolute top-full left-2/4 translate-x-[-50%] w-[283px] flex items-center justify-center pt-2 whitespace-nowrap">
        {selectedIndex > -1 && selectedItem && <DerivativeResultActions data={selectedItem} onCancel={handleCancel} />}
      </div>
    </>
  );
};

export const wrapImageOverlayer = (Overlayer) =>
  React.memo((props) => {
    const { currentElementTool, isEditing, isMiniMode, element, viewport } = props;
    const isActive = currentElementTool === 'generator' && isEditing;

    if (isActive) {
      return <GeneratorOverlayer isMiniMode={isMiniMode} viewport={viewport} element={element} />;
    }

    return <Overlayer {...props} />;
  });
